import { MEPSDKType } from './types';

export abstract class BaseChat {
  domain: string;
  containerId: string;
  mepsdk: MEPSDKType;

  constructor(mepsdk: MEPSDKType, domain: string, containerId: string) {
    this.mepsdk = mepsdk;
    this.domain = domain;
    this.containerId = containerId;
  }

  abstract launch(channelId: number): void;

  setup(token?: string) {
    const config: {
      baseDomain: string;
      deployDirectory: string;
      accessToken?: string;
      fontFaceLink?: string;
    } = {
      baseDomain: this.domain,
      deployDirectory: 'web',
    };

    if (token) {
      config.accessToken = token;
    }

    this.mepsdk.setup(config);
  }

  minimize() {
    this.mepsdk.hide();
  }

  maximize() {
    this.mepsdk.show();
  }

  end(): void {
    if (this.mepsdk) {
      this.mepsdk.unlink();
    } else {
    }
  }
}
